module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img21.7ecdc3c7.jpg";